<div class="add-statement">
  <!-- Start Add Modal Header -->
  <div class="modal-header-full mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-file-invoice-dollar header-icon"
          [ngClass]="{'m-left-11':!editModeStatement(),'m-left-18':editModeStatement()}"></i>

        <div class="modal-description-full width-100p p-relative">
          <app-input id="statement-title" type="text" placeholder="Statement name*"
            styleClassInput="width-100p font-bold" [maxLength]="100"
            [theme]="focus?.title || !statement?.name ? 'secondary' : 'light'" [fontSize]="16"
            [disabled]="!isEditMode && !!statementId || editModeStatement()" [value]="statement.name"
            [isInvalid]="errors.title" [autoFocus]="true" (appFocus)="focusInput('name')" (appBlur)="blurInput('name')"
            (appChange)="handleChange('name', $event)">
          </app-input>
        </div>

        <ng-container *ngIf="editModeStatement()">
          <button *ngIf="statementId" class="btn btn-secondary btn-rorder pointer btn-submit mr-2"
            [disabled]="isSendingStatement" (click)="openSendStatementDialog()">
            <span>Send</span>
          </button>

          <button *ngIf="showMultipleQBO" class="btn btn-white btn-bulk-payment btn-border pointer btn-submit mr-2"
            [disabled]="disableQbo" (click)="postToQbo()">
            <i class="qb-icon"><img src="../../../../assets/img/icon/quickbooks-icon.svg" alt=""></i>
            <span [ngClass]="{ 'pr-2': isPostingToQbo }" class="fw-600 font-14">Post to QBO</span>
            <i *ngIf="isPostingToQbo" class="far fa-spinner rotate"></i>
          </button>

          <button *ngIf="statementId" class="btn btn-white btn-bulk-payment btn-border btn-submit mr-2"
            [disabled]="isProcessing || isStateRestricted()" (click)="openCreateBulkPaymentDialog()">
            <i class="fal fa-plus font-14"></i>

            <span class="fw-600 font-14">Bulk payment</span>

            <i *ngIf="isProcessing" class="far fa-spinner rotate ml-2"></i>
          </button>

          <div>
            <app-dropdown id="d-action" listId="d-action-list" field="title" itemWidth="150px" scrollHeight="150px"
              itemMargin="-140px" [options]="statementOptions" [isDropdownIconVisible]="false"
              [hasCustomOpenTemplate]="true" [hasCustomItemTemplate]="true">
              <ng-template let-item appTemplate="open-dropdown-btn">
                <i class="far fa-ellipsis-v font-20 pointer"></i>
              </ng-template>

              <ng-template let-item appTemplate="item">
                <div class="width-100p" *ngIf="item.value === 'download' && isStatementZipFileEnabled"
                  (click)="handleZipDownload()">
                  <i class="fal fa-save item-icon"></i>
                  <span class="item-title">{{ item?.title }}</span>
                </div>

                <div class="width-100p" *ngIf="item.value === 'print'" (click)="handlePrint()">
                  <i class="fal fa-print item-icon"></i>
                  <span class="item-title">{{ item?.title }}</span>
                </div>
              </ng-template>
            </app-dropdown>
          </div>
        </ng-container>
        <i id="statement-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i>
      </div>
    </div>
  </div>
  <!-- End Add Modal Header -->

  <!-- Statement body -->
  <div class="ui-g statement-body pt-0 pb-0 border-bottom-light">

    <div class="ui-g-12 inputs-column-spacing statement-inner-body">
      <div *ngIf="isStateRestricted() && statementId" class="font-12 ro-restricted-msg">
        <i class="fal fa-lock pr-1"></i>
        <span>
          This statement contains an RO that is currently being edited, therefore a bulk payment cannot be made.
        </span>
      </div>

      <!-- Start Left panel -->
      <div class="ui-g-12 p-zero" *ngIf="dataMode === 'openFromAccounts'">
        <span class="pb-1 pr-2 font-600">Customer Name: </span>
        <span class="view-date w-100">{{customerName}} </span>
      </div>

      <div class="ui-g-9 p-zero left-box">
        <div *ngIf="isCustomerPaymentEnabled && unappliedAmount"
          class="ui-g-12 flex-between-center alert alert-primary unapplied-banner">
          <span class="flex-start-center">
            <i class="far fa-wallet mr-2"></i>
            Customer has <span class="font-600">&nbsp;{{unappliedAmount | currency: usd}}&nbsp;</span> is unapplied
            payments
          </span>

          <span class="pointer font-primary font-600" (click)="openCreateBulkPaymentDialog()">
            Apply Now
          </span>
        </div>

        <div [ngClass]=" [editModeStatement()?'ui-g-9':'ui-g-3']">
          <span *ngIf="!isOpenFromBulk" class="pb-1 pr-2 font-600" [ngClass]="{'m-left-neg-7':!editModeStatement()}">
            {{isRevenueRecognitionSettleEnabled ? 'Finalize date range' : 'Invoice date range'}}
            <span *ngIf="editModeStatement()">:</span>
          </span>

          <span id="statement-mode-date" *ngIf="editModeStatement() && viewModeDate()" class="view-date">
            <!-- <b>{{editModeStatement()}}</b>
            <i>{{viewModeDate()}}</i> -->
            <h6>{{viewModeDate()}}</h6>
          </span>
        </div>

        <div *ngIf="!isOpenFromBulk" class="mb-3" [ngClass]="[editModeStatement()?'ui-g-3':'ui-g-9']">
          <app-report-filter heading="" [ngClass]="{'invisible': editModeStatement() }" [hasExport]="false"
            [hasStatement]="true" [updateUrl]="false" [options]="headerOptions" path="create-statement"
            [hasAccountStatement]="hasAccountStatement" [preAppliedFilter]="preAppliedFilters"
            (filterChange)="filterChange($event, { isDirty: true })">
          </app-report-filter>
        </div>

        <div class="ui-g-12 p-0 mb-8px">
          <p-table class="statement-list" #dt sortField="createdAt" [columns]="cols"
            [value]="editModeStatement() ? currentInvoices : estimates" [sortOrder]="-1" [scrollable]="true"
            [lazy]="true">

            <ng-template pTemplate="header" let-columns>
              <tr class="statement-row-header">
                <th pSortableColumn="checkbox" class="statement-checkbox p-0"
                  [hidden]="(!isEditMode && !!statementId) || editModeStatement()">
                  <app-checkbox inputId="invoice-0" [binary]="false" [disabled]="!isEditMode && !!statementId"
                    [checkState]="tableCheckState" [grayCheckbox]="true" (appChange)="handleAllInvoiceSelect($event)">
                  </app-checkbox>
                </th>

                <th pSortableColumn="invCode" class="invoice-date text-nowrap">
                  Invoice#
                </th>

                <th pSortableColumn="vehicle" class="vehicle text-nowrap">
                  Vehicle
                </th>

                <th *ngIf="!isRevenueRecognitionSettleEnabled" class="invoice-date text-nowrap">
                  Invoice date
                </th>
  
               
                <th *ngIf="isRevenueRecognitionSettleEnabled"  class="invoice-date text-nowrap">
                  Finalize date
                </th>
                

                <th pSortableColumn="paymentStatus" class="payment-status text-nowrap">
                  Status
                </th>

                <th pSortableColumn="totalOrderAmount" class="total-value text-nowrap">
                  Total value
                </th>

                <th pSortableColumn="order" class="amount-remaning text-nowrap">
                  Balance due
                </th>

                <th *ngIf="showMultipleQBO" pSortableColumn="qboStatus" class="qbo-status text-nowrap">
                  Sync status
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr class="statement-grid-row" *ngIf="!isInvoiceLoading">
                <td *ngFor="let col of columns" [ngClass]="col.className" class=""
                  [hidden]="col.field === 'checkbox' && !isEditMode && !!statementId || (col.field === 'checkbox' && editModeStatement())">
                  <div *ngIf="col.field === 'checkbox'" class="ml-m-5">
                    <div class="custom-checkbox-gray" *ngIf="!editModeStatement()">
                      <app-checkbox inputId="invoice-{{rowData?._id}}" [grayCheckbox]="true"
                        [isChecked]="!!selectedInvoices[rowData?._id]" [disabled]="(!isEditMode && !!statementId)"
                        (appChange)="handleStatementSelect(rowData, $event)">
                        <!-- rowData?.lockedInvoiceWithStatement -->
                      </app-checkbox>
                    </div>
                  </div>

                  <div id="statement-inv-code" *ngIf="col.field === 'invCode'"
                    class="hover-underline pointer font-color width-100p flex-column"
                    (click)="openInvoice(rowData?._id)">
                    <span class="font-13 font-secondary-900 m-0 flex-between-center">
                      {{rowData[col.field]}}
                      <span
                        [ngClass]="{'invisible': !rowData?.isAssociatedWithStatement || rowData?.statementId === statement?._id}"
                        [pTooltip]="rowData?.associatedWarningTooltip">
                        <i class="fas fa-exclamation-triangle font-yellow"></i>
                      </span>
                    </span>
                    <span class="font-10">
                      <i class="fal fa-lock lock-icon pr-1" *ngIf="rowData?.isRestricted"></i>
                      <span class="font-gray-45">RO#&nbsp;{{rowData.code}} </span>
                    </span>
                  </div>

                  <div id="statement-vehicle-license" *ngIf="col.field === 'vehicle'" class="flex-column">
                    <span class="width-200px text-truncate m-0">{{rowData[col.field]?.name}}</span>
                    <span class="flex-start-center font-10 font-gray-45" *ngIf="rowData?.vehicleLicense"
                      tooltipPosition="top" [pTooltip]="rowData?.vehicleLicense">
                      {{rowData?.vehicleLicense}}
                    </span>
                  </div>

                  <div  id="statement-invoice-date" class="width-100p" *ngIf="col.field === 'invoiceDate' && !isRevenueRecognitionSettleEnabled">
                    <div class="flex-start-center">
                      <span class="text-nowrap">{{rowData[col.field] | date: 'MMM d, yyyy'}}</span>
                      <span *ngIf="rowData.isOutSchedule && selectedInvoices[rowData._id]"
                        [pTooltip]="rowData.outSideFilterRangeTooltip">
                        <i class="pl-2 fas fa-calendar-exclamation font-orange"></i>
                      </span>
                    </div>
                  </div>

                  <div  id="statement-invoice-date" class="width-100p" *ngIf="col.field === 'finalizeDate' && isRevenueRecognitionSettleEnabled">
                    <div class="flex-start-center">
                      <span class="text-nowrap">{{rowData[col.field] | date: 'MMM d, yyyy'}}</span>
                      <span *ngIf="rowData.isOutSchedule && selectedInvoices[rowData._id]"
                        [pTooltip]="rowData.outSideFilterRangeTooltip">
                        <i class="pl-2 fas fa-calendar-exclamation font-orange"></i>
                      </span>
                    </div>
                  </div>

                  <div id="statement-payment-status" class="width-100p" *ngIf="col.field === 'paymentStatus'">
                    <div>
                      <span class="font-13 font-secondary-900">
                        {{rowData[col.field]}}
                      </span>
                    </div>
                  </div>

                  <div id="statement-total-order-amount" class="width-100p flex-column"
                    *ngIf="col.field === 'totalOrderAmount'">
                    <span class="text-truncate m-0 font-bold">
                      {{rowData[col.field] || 0 | currency: usd}}
                    </span>
                  </div>

                  <div id="statement-amount-remaning" class="width-100p" *ngIf="col.field === 'amountRemaning'">
                    <div>
                      <span class="font-13 font-secondary-900">
                        {{rowData[col.field] || 0 | currency:usd}}
                      </span> <br />
                    </div>
                  </div>
                  <div class="width-100p" *ngIf="showMultipleQBO && col.field === 'isSync'"
                    (click)="tryPostingAgain(rowData._id,rowData.quickbook)">
                    <div>
                      <span class="font-13 font-secondary-900 pointer">
                        {{rowData[col.field] }}
                      </span> <br />
                    </div>
                  </div>
                  <div class="width-100p" *ngIf="showMultipleQBO && col.field === 'isQBOSync'"
                    (click)="tryPostingAgain(rowData._id,rowData.quickbook)">
                    <div>
                      <span class="font-13 font-secondary-900">
                        Pending
                      </span> <br />
                    </div>
                  </div>

                </td>
              </tr>
            </ng-template>
          </p-table>
          <div *ngIf="!editModeStatement() && !isInvoiceLoading && noRecFound"
            class="mt-4 width-100p ui-g-12 text-center not-found">
            <span class="font-gray-35 font-12 mt-2">No data</span>
          </div>

          <div *ngIf="editModeStatement() && !isInvoiceLoading && currentInvoices.length === 0
          && estimates.length > 0" class="mt-4 width-100p ui-g-12 text-center not-found">
            <span class="font-gray-35 font-12 mt-2">No data</span>
          </div>

          <div class="flex-center-center mt-4 width-100p" *ngIf="isInvoiceLoading">
            <span class="pr-2">Loading</span>
            <i class="fal fa-spinner rotate"></i>
          </div>
        </div>
      </div>

      <!-- Start Right Panel -->
      <div class="ui-g-3 p-zero right-box">
        <div class="ui-g-12 p-0 mb-2 ">
          <!-- No of invoices -->
          <div id="statement-inv-total" class="label-row mb-1 border-bottom">
            <div class="label-heading font-bold">
              Invoices
            </div>
            <div class="label-value float-right font-700">
              {{statementTotal.count}}
            </div>
          </div>

          <!-- Total amount of invoices -->
          <div id="statement-invoices" class="label-row">
            <div class="label-heading">
              Invoices total
            </div>
            <div class="label-value float-right">
              {{statementTotal.total | currency: usd}}
            </div>
          </div>

          <!-- Total paid amount of invoices -->
          <div id="statement-paid-date" class="label-row">
            <div class="label-heading">
              Paid to date
            </div>
            <div class="label-value float-right">
              {{statementTotal.paid | currency: usd}}
            </div>
          </div>

          <!-- Total balance due of invoices -->
          <div id="statement-balance-due" class="label-row">
            <div class="label-heading font-bold">
              Balance due
            </div>
            <div class="label-value float-right font-bold">
              {{statementTotal.due | currency: usd}}
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-0 mb-2 ">
          <div class="label-row mb-1 border-bottom">
            <div class="label-heading font-bold">
              Activity log
            </div>
          </div>

          <div class="">
            <!-- Activity List -->
            <ul class="activity-list">
              <div class="activity-list-item-wrapper" *ngFor="let activity of activities">
                <li id="statement-activity-list" class="activity-list-item flex-start-start" tooltipPosition="top"
                  tooltipStyleClass="payment-history-tooltip" [pTooltip]="activity.text">
                  <div>
                    <span class="acitivity-icon">
                      <i [class]="statementActivityIcons[activity.entityAction] || 'fas fa-file-invoice'"></i>
                    </span>
                  </div>

                  <div class="flex-column">
                    <p class="mb-0 font-12 font-600 text-truncate activity-title font-bold">
                      {{activity.title}}
                    </p>
                    <p class="mb-0 font-10 activity-title activity-user-logs">
                      by {{activity.actionBy}} {{activity.createdAt}}

                      <span *ngIf="activity?.data?.includeContact">
                        to
                        <span *ngIf="activity?.data?.type !== 'email'">
                          {{activity?.data?.contact | mask: '(000) 000-0000'}}
                        </span>
                        <span *ngIf="activity?.data?.type === 'email'">
                          {{activity?.data?.contact}}
                        </span>
                      </span>
                    </p>
                  </div>
                </li>
                <li class="divider"></li>
                <li class="node"></li>
              </div>
            </ul>

            <div class="no-activity-log" *ngIf="!activities?.length">
              No activity
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Add statement Body -->
  </div>

  <!-- Statement footer -->
  <div *ngIf="!isOpenFromBulk" class="ui-g-12 flex-between-center dialog-footer statement-footer">
    <div class="part-add-dialog-footer d-flex justify-content-between width-100p">
      <div>
        <p class="m-0" *ngIf="isDownloadingStatement">
          <span class="pr-2">Generating Invoice PDFs and Zip file might take a few minutes</span>
          <i class="fal fa-spinner rotate"></i>
        </p>
      </div>

      <div>
        <button class="btn btn-border pointer btn-submit mr-2 btn-width" (click)="closeDialog()"
          *ngIf="(!editModeStatement() && !statementId) || (statementId && editModeStatement())">
          Close
        </button>

        <button class="btn btn-border pointer btn-submit mr-2 btn-width" (click)="backToPreviousViewMode(true)"
          *ngIf="!editModeStatement() && (statementId && isEditMode)">
          Back
        </button>

        <ng-container *ngIf="!editModeStatement(); else noMode">
          <button *ngIf="!statementId || (statementId && isEditMode)"
            class="btn btn-primary pointer btn-submit btn-width"
            [disabled]="isSavingStatement || isPostingToQbo || hasAnyRestrictedInv" (click)="onSubmit()">
            <span [ngClass]="{ 'pr-2': isSavingStatement }">
              Save
            </span>
            <i *ngIf="isSavingStatement" class="far fa-spinner rotate"></i>
          </button>
        </ng-container>

        <ng-template #noMode>
          <button *ngIf="!statementId || (statementId && isEditMode)"
            class="btn btn-primary pointer btn-submit btn-width"
            [disabled]="isSavingStatement || isPostingToQbo || hasAnyRestrictedInv" (click)="onEdit()">
            <span [ngClass]="{ 'pr-2': isSavingStatement }">
              Edit
            </span>
            <i *ngIf="isSavingStatement" class="far fa-spinner rotate"></i>
          </button>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- End Statement  Footer -->
</div>
